<template>
  <b-modal
    id="modal-lead-details"
    centered
    class="modal-lead-details"
    :no-enforce-focus="true"
  >
    <div class="modal-lead-details-itens">
      <div class="modal-lead-details-itens-header">
        <button
          class="modal-lead-details-itens-close"
          @click="$bvModal.hide('modal-lead-details')"
        >
          <div class="modal-lead-details-itens-close--icon">
            <img
              class="img-fluid"
              src="@/assets/img/close-modal.png"
              alt="icon close"
              title="icon close"
            />
          </div>
        </button>
      </div>
      <div class="modal-lead-details-itens-body">
        <div class="modal-lead-details__information">
          <h3>Informações:</h3>
          <div class="modal-lead-details__information-div">
            <p>
              Empresa: <span>{{ lead.company }}</span>
            </p>
            <p>
              Responsável: <span>{{ lead.name }}</span>
            </p>
            <p>
              Email: <span>{{ lead.email }}</span>
            </p>
            <p>
              Número do Whatsapp: <span>{{ lead.number_whats_app }}</span>
            </p>
            <p>
              Preferência de contato: <span>{{ lead.type_contact }}</span>
            </p>
            <p>
              Mensagem: <span>{{ lead.message }}</span>
            </p>
            <p>
              Cargo: <span>{{ lead.position_name }}</span>
            </p>
            <p>
              Departamento: <span>{{ lead.department_name }}</span>
            </p>
            <p>
              Número de colaboradores:
              <span>{{ lead.number_of_collaborators }}</span>
            </p>
            <p>
              Data e horário:
              <span>{{ lead.created_at | dateTimeFormat }}</span>
            </p>
            <p>
              Status:
              <span class="status-lead" :class="classStatusLead">{{
                lead.lead_status
              }}</span>
            </p>
          </div>
        </div>
        <div class="modal-lead-details__actions">
          <h3>Ações:</h3>
          <div class="modal-lead-details__actions-btns">
            <button class="status-new" @click="handleClickAction(1, 'Novo')">
              Novo
            </button>
            <button
              class="status-tentative"
              @click="handleClickAction(2, 'Teve tentativa de contato')"
            >
              Tentativa de contato
            </button>
            <button
              class="status-in-progress"
              @click="handleClickAction(3, 'Em progresso')"
            >
              Em progresso
            </button>
            <button
              class="status-qualified"
              @click="handleClickAction(4, 'Negócio qualificado/fechado')"
            >
              Negócio qualificado/fechado
            </button>
            <button
              class="status-not-qualified"
              @click="handleClickAction(5, 'Não qualificado')"
            >
              Não qualificado
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    lead: {
      type: Object,
      required: true,
    },
    classStatusLead: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    ...mapActions("Company", ["saveLeads"]),
    async handleClickAction(idLeadStatus, leadStatus) {
      this.$swal
        .fire({
          html: `Tem certeza que deseja mudar o status do lead para:
          <b style=" display: block; font-size: 24px; color: #EF0000;">${leadStatus}?<b>`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#EF0000",
          confirmButtonText: "SIM",
          cancelButtonText: "NÃO",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.lead.id_lead_status = idLeadStatus;

            const leadFormatted = { ...this.lead };
            delete leadFormatted.department_name;
            delete leadFormatted.position_name;
            delete leadFormatted.lead_status;

            await this.saveLeads(leadFormatted);

            const message = `Status do lead alterado com sucesso para: <br> <b>${leadStatus}!</b>`;
            this.$swal.fire({
              icon: "success",
              html: message,
            });
            this.$bvModal.hide("modal-lead-details");
          }
        });
    },
  },
};
</script>

<style lang="scss">
#modal-lead-details {
  .modal-header,
  .modal-footer {
    display: none;
  }
  .modal-content {
    box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.16);
    border: 0;
    border-radius: 20px;
  }
  .modal-dialog {
    max-width: 700px;
  }
  .modal-body {
    padding: 0;
  }
}
.modal-lead-details {
  &-itens {
    &-close {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      padding: 10px;
      border: 0;
      background: 0;
      transition: 500ms;
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    &-body {
      padding: 25px 20px 30px 20px;

      .status-new {
        background: #e2e8f0;
        color: #334155;
      }
      .status-tentative {
        background: #fef3c7;
        color: #92400e;
      }
      .status-in-progress {
        background: #dbeafe;
        color: #1e40af;
      }
      .status-qualified {
        background: #dcfce7;
        color: #166534;
      }
      .status-not-qualified {
        background: #fee2e2;
        color: #991b1b;
      }
    }
  }
  &__information {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid var(--gray-light);
    h3 {
      font-size: 24px;
      font-family: "Font Bold";
      color: var(--black);
      text-transform: uppercase;
      margin-bottom: 30px;
    }
    &-div {
      display: grid;
      grid-template-columns: 2fr 2fr;
      @media (max-width: 991px) {
        grid-template-columns: auto;
      }
    }
    p {
      font-size: 16px;
      font-family: "Font Bold";
      color: var(--black);
      span {
        display: block;
        font-family: "Font Regular";
        color: var(--gray-dark);
      }
      .status-lead {
        width: max-content;
        padding: 5px 15px;
        font-family: "Font Bold";
        border-radius: 20px;
      }
    }
  }
  &__actions {
    h3 {
      font-size: 24px;
      font-family: "Font Bold";
      color: var(--black);
      text-transform: uppercase;
      margin-bottom: 30px;
    }
    &-btns {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      button {
        padding: 10px 20px;
        border-radius: 30px;
        border: 0;
        font-size: 18px;
        font-family: "Font Bold";
        transition: 500ms;
        &:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
